"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var paddingRegular = _ref.paddingRegular;
  return {
    display: 'flex',
    flexDirection: 'column',
    '& > ul.media-list': {
      listStyleType: 'none',
      margin: paddingRegular,
      padding: 0
    }
  };
}